import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";

const AccountancyPrograms = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80",
    heading: "Financial Accounting",
    introduction: "Learn fundamental accounting principles and financial reporting.",
    buttonText: "LEARN MORE",
    route: "financial-accounting",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80",
    heading: "Management Accounting",
    introduction: "Develop cost analysis and managerial accounting skills.",
    buttonText: "LEARN MORE",
    route: "management-accounting",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80",
    heading: "Auditing & Assurance",
    introduction: "Master auditing procedures and financial statement analysis.",
    buttonText: "LEARN MORE",
    route: "auditing-assurance",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80",
    heading: "Taxation",
    introduction: "Learn tax laws, compliance, and tax planning strategies.",
    buttonText: "LEARN MORE",
    route: "taxation",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80",
    heading: "Financial Management",
    introduction: "Develop financial planning and investment analysis skills.",
    buttonText: "LEARN MORE",
    route: "financial-management",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80",
    heading: "Business Law",
    introduction: "Understand legal aspects of business and accounting.",
    buttonText: "LEARN MORE",
    route: "business-law",
  },
];

const AccountancyProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={AccountancyPrograms}
        basePath="/courses/accountancy"
      />
    </div>
  );
};

export default AccountancyProgramsCard;
